import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * ScrollManager Component
 * 
 * Manages scroll behavior across route changes:
 * - PUSH/REPLACE: Scroll to top (new navigation)
 * - POP: Preserve scroll position (browser back/forward)
 * 
 * This prevents the "stuck at bottom" issue when navigating
 * from footer links or other deep scroll positions.
 */
function ScrollManager() {
  const { pathname } = useLocation();
  const navigationType = useNavigationType(); // 'PUSH', 'POP', 'REPLACE'

  useEffect(() => {
    // Preserve scroll position when using browser back/forward
    if (navigationType === 'POP') {
      return;
    }

    // For new navigation (clicking links, programmatic navigation),
    // scroll to top instantly
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant', // Use 'instant' for immediate jump, 'smooth' for animation
    });
  }, [pathname, navigationType]);

  return null; // This component doesn't render anything
}

export default ScrollManager;
